module.exports = __webpack_public_path__ + "static/media/LandingPage.36ae35f1.png";